import useUser from "../../../hooks/useUser";

const useSuperAdmin = () => {
  const { user } = useUser();
  return user?.roles.find((el) => el.id === 1);
};

export default useSuperAdmin;
